// /connect — the Allow page for ChatGPT and Claude sign-in. Every retailer-facing string, as pure
// functions so Jest can test them. Approved copy: spec dashboard/buyer-insights-chatgpt-connector.md §4.5, §7.4.
//
// The page receives the OAuth authorize query unchanged. Which assistant is asking follows from its
// redirect_uri; the server checks the same allowlist again on Allow (oauth.py REDIRECTS).

const ASSISTANTS = [
  { pattern: /^https:\/\/chatgpt\.com\//, assistant: 'ChatGPT', company: 'OpenAI' },
  { pattern: /^https:\/\/claude\.ai\//, assistant: 'Claude', company: 'Anthropic' },
];

// {assistant, company} for the query's redirect_uri, or null when it is not one we know.
export function assistantFor(search) {
  const redirect = new URLSearchParams(search).get('redirect_uri') || '';
  const hit = ASSISTANTS.find((a) => a.pattern.test(redirect));
  return hit ? { assistant: hit.assistant, company: hit.company } : null;
}

export function connectCopy({ assistant, company }, { email, shop }) {
  return {
    heading: `Connect HandOff to ${assistant}`,
    who: `You are logged in as ${email} for ${shop}.`,
    notYou: 'Not you?',
    logOut: 'Log out',
    what:
      `${assistant} can then read your HandOff data: sizes still wanted, how your size depth compares with ` +
      'your partners, shoppers sent and received, and your commission items: orders you sent and received, ' +
      'with their status and amounts.',
    limits:
      `${assistant} can only read. It cannot change anything. It does not see shopper names, emails or addresses.`,
    choice: `You choose to share this data with ${assistant}. ${company} then handles it under your own agreement with them.`,
    stop: 'You can stop this at any time in Settings › AI assistants.',
    cancel: 'Cancel',
    allow: 'Allow',
    done: `Done. You can go back to ${assistant}.`,
  };
}

// The server's error_code (POST /oauth/consent) → the message on the page.
export function errorMessage(code, assistant) {
  switch (code) {
    case 'key_limit':
      return 'Your shop has 10 keys. Block one in Settings › AI assistants first.';
    case 'inactive':
      return 'Your login is not active. Ask HandOff for help.';
    case 'server':
      return 'Something went wrong. Try again.';
    case 'bad_request':
    default:
      return `This link does not work any more. Go back to ${assistant || 'your assistant'} and connect again.`;
  }
}
